export type { repCodeType } from '@impres-development/assets/client'

export type quoteType = {
  QuoteId: string
  QuoteNumber: string
  Version: number
  RFQNumber: string | null
  RFQDueDate: Date | null
  ContractVehicle: string | null
  ContractNumber: string | null
  QuoteDate: Date | null
  ExpirationDate: Date | null
  Status: string
  QuoteDescription: string | null
  TotalCost: number
  PartnerFees: number
  ContractFees: number
  TotalFees: number
  SubtotalNoFees: number
  CreditCardFees: number
  Subtotal: number
  ShippingHandling: number
  Tax: number
  GrandTotal: number
  GrossProfit: number
  GrossProfitPercentage: number
  GovPayTerms: string
  CRMOpportunity: string | null
  CRMContact: string | null
  CRMAccount: string | null
  RepCode: string
  Owner: string | null
  Name: string
  Comments: string | null
  CreatedDate: Date
  LastModifiedDate: Date
  OrderId: string | null
}

export type quoteLineType = {
  LineItemId: string
  LineNumber: number
  QuoteId: string
  Provider: string | null
  Manufacturer: string | null
  MfrPartNumber: string | null
  DisplayPartNumber: string | null
  VendorPartNumber: string | null
  Description: string | null
  Qty: number | null
  UnitCost: number | null
  ExtCost: number | null
  ContractCeilingPrice: number | null
  OEMCode: string | null
  CLIN: string | null
  MSRP: number | null
  UnitPrice: number | null
  ExtPrice: number | null
  ProductType: string | null
  StartDate: Date | null
  EndDate: Date | null
  ServiceTag: string | null
  LicenseSN: string | null
  UnitOfMeasure: string | null
  Notes: string | null
  TAA: string | null
  CountryOfOrigin: string | null
  ContractCatalog: string | null
  ContractNumber: string | null
  CreditCardFee: number | null
  PartnerFees: number | null
  ContractFees: number | null
  TotalFees: number | null
  Margin: number | null
  Compliance: ComplianceStatus | null
  Scrm: ComplianceStatus | null
  Bundle: string | null
  VendorQuoteId: string | null
  UPC: string | null
  UNSPSC: string | null
  EnergyStar: string | null
  EPEAT: string | null
  ProductCategory?: string | null
  ProductCategorySource?: string | null
  ProductCategoryConfidence?: number | null
  ProductCategoryKey?: string | null
  ProductCategoryAttempts?: number
  ProductCategoryAttemptAt?: Date | string | null
}

export enum ComplianceStatus {
  Compliant = 'compliant',
  NotCompliant = 'not compliant',
  PendingApproval = 'pending approval',
}

export type salesforceOpportunityType = {
  Id: string
  Name: string
  CloseDate: Date | null
  StageName: string
  ForecastCategoryName: string
  Line_Of_Business__c: string | string[]
  Set_Asides__c: string | string[]
  Account: salesforceAccountType | null
  Owner: {
    Name: string
    Email: string | null
    Phone: string | null
  }
  Contact: salesforceContactType | null
}

export type salesforceAccountType = {
  Id: string
  Name: string
  Parent: {
    Name: string
  } | null
  Top_Level_Account__c: string | null
  DoD_CIV_ISG__c: string | null
  Owner: {
    Name: string
    Email: string | null
    Phone: string | null
  }
}

export type salesforceContactType = {
  Id: string
  Name: string
  Email: string
  Phone: string
  Default_Billing_Address__c: {
    street: string
    city: string
    state: string
    postalCode: string
  } | null
  Default_Shipping_Address__c: {
    street: string
    city: string
    state: string
    postalCode: string
  } | null
}

export type vendorQuoteType = {
  VendorQuoteId: string
  QuoteId: string
  VendorName: string | null
  VendorQuoteNumber: string | null
  ExpirationDate: Date | null
  TotalAmount: number | null
  Source: string | null
}

export type customViewTemplateType = {
  TemplateName: string
  Columns: { Name: string; Width: number; Order: number }[]
}

export type supplierQuoteAiLineReviewType = {
  LineNumber: number
  confidence: number
  optionGroup: string | null
  note: string | null
  warnings: string[]
}

export type supplierQuoteAiResponseType = {
  lineItems: quoteLineType[]
  header: {
    vendorName: string | null
    vendorQuoteNumber: string | null
    totalAmount: number | null
    expirationDate: string | null
  }
  review: {
    model: string
    quoteDate: string | null
    supplierMatched: boolean
    warnings: string[]
    lines: supplierQuoteAiLineReviewType[]
  }
}

export type supplierQuoteImportStateType = {
  quoteId: string
  lineItems: quoteLineType[]
  quoteNumber: string
  supplier: string
  totalAmount: number | null
  expirationDate: Date | null
  file: File | null
}

export type sewpTrLineType = {
  QuoteId: string
  ContractNumber: string
  Status: string
  RequestLineId: string
  RequestId?: string
  Clin: string
  ClinType: string
  BundleFlag: boolean
  Provider: string
  PartNumber: string
  ModelName?: string
  ProductLine?: string
  ClinQty: number
  ClinUnit?: string
  ScrmFlag?: boolean
  ScrmComment?: string
  DiscountClass: string
  DiscountSubClass: string
  ProductClass?: string
  MaFlag?: string
  ListPrice: number
  SewpPrice: number
  GsaPrice?: number
  Rebate: number
  DiscountPercent: number
  EpeatFlag: string
  EnergyStarFlag: string
  BackupDataFlag: string
  TaaFlag: string
  VisibleFlag: boolean
  ProductCondition: string
  ItemDescription: string
  ShortDescription?: string
  EolDate?: Date
  EquivalentClin?: string
  ReplacementClin?: string
  BmReasonCode?: string
  BundlePart?: string
  SsPart?: string
  Unspsc?: string
}

export type sewpTrHeaderType = {
  RequestId: string
  TrNumber: string
  ContractNumber: string
  TotalClins: number
  Status: string
  EmailFile?: string | null
}

export type itesArLineType = {
  QuoteId: string
  Status: string
  RequestLineId: string
  RequestId?: string
  TransactionType: string
  ContractNumber: string
  CatalogNumber: number
  MeiComponent: string
  MajorEndItem: string
  CatalogClin: string
  VendorPartNumber: string
  Manufacturer: string
  MfrPartNumber: string
  Description: string
  ListPrice: number
  Ites4hSellPrice: number
  PercentOffListPrice: number
  Unspsc?: string
}

export type itesArHeaderType = {
  RequestId: string
  ArNumber: string
  ContractNumber: string
  TotalClins: number
  Status: string
  ExportedFile?: string | null
}
